module.exports = __webpack_public_path__ + "img/y_2022.085673fb.png";